import classnames from 'classnames'
import { connect as connectRedux } from 'react-redux'

import { Segment } from './Global/Segment'
import { SegmentEvents } from './Global/SegmentEvents'
import { UiSetup } from './Interfaces/CompanyInterface'

export function setBaseClass(baseClass: string) {
  return (name?): string =>
    name
      ? classnames(name)
          .split(' ')
          .map((c) => (c ? `${baseClass}${c}` : baseClass))
          .join(' ')
      : baseClass
}

export function deleteAllCookies() {
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    if (cookie.includes('CookieConsent')) {
      document.cookie = cookie
    } else {
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
    }
  }
}

const getLogoutUrl = (uiSetup?: UiSetup) => {
  let domainToLogoutUrl: Record<string, string> = {
    'invoicing.staging.shine.co': 'https://login.staging.shine.co/login/login',
    'invoicing.shine.co': 'https://login.shine.co/login/login',
  }

  if (uiSetup === UiSetup.SupernavInvoicingAccounting) {
    domainToLogoutUrl = {
      'invoicing.staging.shine.co': 'https://app.staging.shine.co/logout',
      'invoicing.shine.co': 'https://app.shine.co/logout',
      'secure.zervant.com': 'https://app.shine.co/logout',
      'test.zerv.me': 'https://app.staging.shine.co/logout',
    }
  }

  return domainToLogoutUrl[window.location.hostname] || '/login/login/'
}

export const clearSession = () => {
  localStorage.clear()
  sessionStorage.clear()
  deleteAllCookies()
}

export const logout = (isSessionExpired = false, uiSetup?: UiSetup) => {
  clearSession()

  Segment.track(SegmentEvents.common.signedOut, { context: isSessionExpired ? 'token_expire' : 'user' })
  Segment.reset()

  window.location.href = getLogoutUrl(uiSetup)
}

export const externallyInitiatedLogout = (isSessionExpired = false) => {
  clearSession()

  Segment.track(SegmentEvents.common.signedOut, { context: isSessionExpired ? 'token_expire' : 'user' })
  Segment.reset()

  window.location.href = getLogoutUrl()
}

export function connect(mapStateToProps, mapDispatchToProps?, mergeProps?, options?) {
  return (target) => connectRedux(mapStateToProps, mapDispatchToProps, mergeProps, options)(target) as any
}
